$(function() {
  if($('.map-search').length) {
      /*
      1080px以上の時
    */
    $('.js-left-sidebar .js-left-sidebar-btn,.js-right-sidebar .js-right-sidebar-btn').on(oEventNames.end, function (event) {
      if (!bIsScrolling) {
        event.preventDefault();
        if($(this).hasClass('open-wrap')) {
          $(this).removeClass('open-wrap').addClass('close-wrap');
          $(this).parent('.js-left-sidebar ').removeClass('open-sidebar').addClass('close-sidebar');
          $(this).parent('.js-right-sidebar ').removeClass('open-sidebar').addClass('close-sidebar');
        }else if($(this).hasClass('close-wrap')){
          $(this).removeClass('close-wrap').addClass('open-wrap');
          $(this).parent('.js-left-sidebar').removeClass('close-sidebar').addClass('open-sidebar');
          $(this).parent('.js-right-sidebar').removeClass('close-sidebar').addClass('open-sidebar');
        }
      }
    });
    /*
      1080px以下の時
    */
    $('.footer-fixed .js-search-left-btn').on(oEventNames.end, function (event) {
      if (!bIsScrolling) {
        event.preventDefault();
        // 閉じるとき
        if ($('.js-left-sidebar').css('display') == 'block') {
          $('.js-left-sidebar').slideUp();
          $(this).html('<i class="fas fa-search"></i>業者をさがす');
          $(this).removeClass('green');
          setTimeout(function () {
            $('.js-left-sidebar').removeClass('sp-open-sidebar');
          }, 300);
        }else {
          // 開くとき
          $('.js-left-sidebar').slideDown();
          $('.js-right-sidebar').slideUp();
          $(this).html('<i class="fas fa-chevron-down"></i>地図を見る');
          $(this).addClass('green');
          $('.footer-fixed .js-search-right-result').html('<i class="fas fa-bars"></i>検索結果を見る');
          $('.footer-fixed .js-search-right-result').removeClass('green');
          setTimeout(function () {
            $('.js-left-sidebar').addClass('sp-open-sidebar');
          }, 300);
        }
      }
    });
    $( '.footer-fixed .js-search-right-result').on(oEventNames.end, function (event) {
      if (!bIsScrolling) {
        event.preventDefault();
        // 閉じるとき
        if ($('.js-right-sidebar').css('display') == 'block') {
          $(this).html('<i class="fas fa-bars"></i>検索結果を見る');
          $(this).removeClass('green');
          $('.js-right-sidebar').slideUp();
        }else{
          // 開くとき
          $('.js-right-sidebar').slideDown();
          $('.js-left-sidebar').slideUp();
          $(this).html('<i class="fas fa-chevron-down"></i>地図を見る');
          $(this).addClass('green');
          $('.footer-fixed .js-search-left-btn').html('<i class="fas fa-search"></i>業者をさがす');
          $('.footer-fixed .js-search-left-btn').removeClass('green');
          setTimeout(function () {
            $('.js-left-sidebar').removeClass('sp-open-sidebar');
          }, 300);
        }
      }
    });

    /*
      1080px以下の閉じるボタン
    */
    $('.js-left-close-btn').on(oEventNames.end, function (event) {
      if (!bIsScrolling) {
        event.preventDefault();
        const elem = document.activeElement;
        elem.blur();
        if ($('.js-left-sidebar').css('display') == 'block') {
          $('.js-left-sidebar').slideUp();
          $('.footer-fixed .js-search-left-btn').html('<i class="fas fa-search"></i>業者をさがす');
          $('.footer-fixed .js-search-left-btn').removeClass('green');
          setTimeout(function () {
            $('.js-left-sidebar').removeClass('sp-open-sidebar');
          }, 300);
        }else {
          $('.js-left-sidebar').slideDown();
          $('.footer-fixed .js-search-left-btn').html('<i class="fas fa-chevron-down"></i>地図を見る');
          $('.footer-fixed .js-search-left-btn').addClass('green');
          setTimeout(function () {
            $('.js-left-sidebar').addClass('sp-open-sidebar');
          }, 300);
          $('.js-right-sidebar').slideUp();
        }
      }
    });
    $('.js-right-close-btn').on(oEventNames.end, function (event) {
      if (!bIsScrolling) {
        event.preventDefault();
        if ($('.js-right-sidebar').css('display') == 'block') {
          $('.js-right-sidebar').slideUp();
          $('.footer-fixed .js-search-right-result').html('<i class="fas fa-bars"></i>検索結果を見る');
          $('.footer-fixed .js-search-right-result').removeClass('green');
        }else{
          $('.js-right-sidebar').slideDown();
          $('.js-left-sidebar').slideUp();
          $('.footer-fixed .js-search-right-result').html('<i class="fas fa-chevron-down"></i>地図を見る');
          $('.footer-fixed .js-search-right-result').addClass('green');
          setTimeout(function () {
            $('.js-left-sidebar').removeClass('sp-open-sidebar');
          }, 300);
        }
      }
    });

    // リサイズで要素表示/非表示
    $(window).on('load', function () {
      setTimeout(function () {
      var wid = window.innerWidth;
        if (wid > 1080) { // breakpoint設定する
          $('.js-right-sidebar').show();
          $('.js-left-sidebar').addClass('sp-open-sidebar').show();
        }else{
          $('.js-right-sidebar').hide();
          $('.js-left-sidebar').removeClass('sp-open-sidebar').hide();
          // ページ読み込み時に検索窓を表示
          $('.js-left-sidebar').addClass('sp-open-sidebar').show();
          $('.footer-fixed .js-search-left-btn').html('<i class="fas fa-chevron-down"></i>地図を見る');
          $('.footer-fixed .js-search-left-btn').addClass('green');
        }
      }, 300);
    });
    $(window).on('resize', function () {
      setTimeout(function () {
      var wid = window.innerWidth;
        if (wid > 1080) { // breakpoint設定する
          $('.js-right-sidebar').show();
          $('.js-left-sidebar').show();
        }
      }, 300);
    });
  }
});